import { APP_CONFIG } from "#root/config/constants/app-config.constant";
import { FuseConfig } from "#root/config/interfaces/fuse-config.interface";
import { inject, Injectable } from "@angular/core";
import { FuseConfigService } from "@fuse/services/config";
import { environment } from "environments/environment";

@Injectable({ providedIn: "root" })
export class ThemeService {
  private readonly configService = inject(FuseConfigService);

  applyTheme() {
    const key = `fuse-config-${environment.appTitle}`;
    const saved: FuseConfig | null = JSON.parse(
      localStorage.getItem(key) || "null",
    );

    if (saved) {
      this.configService.config = { ...saved, theme: APP_CONFIG.theme };
    } else {
      this.configService.config = { theme: APP_CONFIG.theme };
    }
  }
}

export function initializeTheme(themeService: ThemeService) {
  return () => themeService.applyTheme();
}
